import Modal from 'react-bootstrap/Modal'
import { Form, Formik } from "formik";
import { TextField } from "../../components/common/TextField/TextField";
import React, { useEffect, useState } from "react";
import { OptionList } from "../../components/common/OptionList/OptionList";
import { Col, Row } from "react-bootstrap";
import ShowNotification from "../../components/common/Notification/ShowNotification";

const AddDataModal = ({ show, addUserTh, setIsCreateUser, ...props }) => {
    const [submitClicked, setSubmitClicked] = useState(false);
    let [showModal, setShowModal] = useState(show);
    let [role, setRole] = useState("user");

    const handleClose = () => {
        setShowModal(false);
        setIsCreateUser(false);
    };

    useEffect(() => {
        if (show) setShowModal(true);
        else setShowModal(false);
    }, [show]);

    let roleList = [
        { id: 'user', name: 'User', status: 1 },
        { id: 'admin', name: 'Admin', status: 1 }
    ];

    return (
        <Formik
            initialValues={{
                name: "",
                email: "",
                password: "",
                password_confirmation: "",
                role: "user",
            }}
            onSubmit={(formValues) => {
                if (!submitClicked) return;

                if (formValues.password !== formValues.password_confirmation) {
                    ShowNotification("Xəta", "Şifrələr uyğun deyil", "danger");
                    return;
                }
                if (formValues.password.length < 8) {
                    ShowNotification("Xəta", "Şifrə ən azı 8 simvol olmalıdır", "danger");
                    return;
                }

                const userInstance = {
                    name: formValues.name,
                    email: formValues.email,
                    password: formValues.password,
                    password_confirmation: formValues.password_confirmation,
                    role: role,
                };

                addUserTh(userInstance);
                setIsCreateUser(false);
            }}
        >
            {() => (
                <Modal show={showModal} onHide={handleClose} size="md">
                    <Modal.Header closeButton>
                        <Modal.Title>İstifadəçi əlavə et</Modal.Title>
                    </Modal.Header>
                    <Form>
                        <Modal.Body>
                            <TextField label="Ad" name="name" type="text" enableLabel='true' />
                            <TextField label="Email" name="email" type="email" enableLabel='true' />
                            <TextField label="Şifrə" name="password" type="password" enableLabel='true' />
                            <TextField label="Şifrə təkrarı" name="password_confirmation" type="password" enableLabel='true' />
                            <Row>
                                <Col>
                                    <OptionList
                                        label="Rol"
                                        data={roleList}
                                        name='role'
                                        selectedItem={role}
                                        setData={setRole}
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button"
                                    className="btn btn-secondary"
                                    onClick={handleClose}>Bağla</button>
                            <button type="submit"
                                    onClick={() => setSubmitClicked(true)}
                                    className="btn btn-primary">Yadda Saxla</button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            )}
        </Formik>
    );
};

export default AddDataModal;
